/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InlineObject1 { 
    /**
     * Errors overview.
     */
    message: string;
    /**
     * A detailed description of each field that failed validation.
     */
    errors: { [key: string]: Array<string>; };
}

